export default __webpack_public_path__ + "static/lv-bd7ff78ee6d6611c7363aa533769048e.svg";